import firebaseApp from "../../../firebaseInit";
import { encrypt, decrypt } from "../../../utils/crypto";

export default {
	async getDataMono(context, payload) {
		console.log('Payload для запиту:', payload);

		// Зберігаємо токен перед використанням
		const userId = context.rootGetters.userId;
		await context.dispatch('saveToken', { token: payload.token, userId });

		const response = await fetch(
			`https://api.monobank.ua/personal/statement/${payload.accountId}/${payload.dateFrom}/${payload.dateTo}`,
			{
				method: "GET",
				headers: {
					"X-Token": payload.token,
				},
			}
		);

		const responseData = await response.json();
		console.log('Отримані дані з Monobank API:', responseData);

		const transactionsObject = {};

		for (let i = 0; i < responseData.length; i++) {
			let key = responseData[i].id
			transactionsObject[`${key}`] = responseData[i];
		}

		console.log('Об\'єкт транзакцій для завантаження у Firebase:', transactionsObject);

		await context.dispatch('uploadDataToFirebase', transactionsObject);
	},


	async getClientDataFromMono(context, payload) {
		console.log('Токен для запиту клієнтської інформації:', payload);

		// Зберігаємо токен
		const userId = context.rootGetters.userId;
		await context.dispatch('saveToken', { token: payload, userId });

		const response = await fetch(
			`https://api.monobank.ua/personal/client-info`,
			{
				method: "GET",
				headers: {
					"X-Token": payload,
				},
			}
		)
			.then((res) => {
				console.log("Card IDs was written");

				return res.json();
			})
			.catch((error) => {
				console.error("Error writing document: ", error);
			});

		const responseData = response;
		console.log('Отримана клієнтська інформація:', responseData);

		let accountsList = []

		for (let i = 0; i < responseData.accounts.length; i++) {
			accountsList.push({
				type: responseData.accounts[i].type,
				id: responseData.accounts[i].id,
			});
		}

		console.log('Список рахунків:', accountsList);

		context.commit('setAccountsList', accountsList);
	},

	async saveToken(context, payload) {
		const { token, userId } = payload;

		// Шифруємо токен за допомогою AES
		const encryptedToken = encrypt(token);

		await firebaseApp.firestore()
			.collection("users")
			.doc(userId)
			.collection("settings")
			.doc("token")
			.set({
				encryptedToken: encryptedToken,
				updatedAt: Date.now()
			})
			.then(() => {
				console.log('Токен успішно збережено (зашифровано)');
			})
			.catch((error) => {
				console.error("Помилка збереження токена: ", error);
				throw new Error("Не вдалося зберегти токен!");
			});
	},

	async getToken(context) {
		const userId = context.rootGetters.userId;

		try {
			const doc = await firebaseApp.firestore()
				.collection("users")
				.doc(userId)
				.collection("settings")
				.doc("token")
				.get();

			if (doc.exists) {
				const data = doc.data();
				if (data && data.encryptedToken) {
					// Розшифровуємо токен
					const decryptedToken = decrypt(data.encryptedToken);
					console.log('Токен успішно завантажено і розшифровано');
					return decryptedToken;
				}
			}

			console.log('Збережений токен не знайдено');
			return null;
		} catch (error) {
			console.error('Не вдалося завантажити токен:', error);
			return null;
		}
	},

	async getTokenMetadata(context, userId) {
		try {
			const doc = await firebaseApp.firestore()
				.collection("users")
				.doc(userId)
				.collection("settings")
				.doc("token")
				.get();

			if (doc.exists) {
				const data = doc.data();
				return {
					updatedAt: data.updatedAt || null
				};
			}

			return null;
		} catch (error) {
			console.error('Не вдалося завантажити метадані токена:', error);
			return null;
		}
	},

	async uploadDataToFirebase(context, transactionsObject) {
		const userId = context.rootGetters.userId;
		const batch = firebaseApp.firestore().batch();

		for (const [transactionId, transaction] of Object.entries(transactionsObject)) {
			const docRef = firebaseApp.firestore()
				.collection("users")
				.doc(userId)
				.collection("transactions")
				.doc(transactionId);

			// set з merge автоматично оновить або створить
			batch.set(docRef, transaction, { merge: true });
		}

		await batch.commit()
			.then(() => {
				console.log("Транзакції успішно збережено у Firebase!");
			})
			.catch((error) => {
				console.error("Помилка збереження транзакцій: ", error);
				throw new Error("Не вдалося завантажити дані в Firebase!");
			});
	},
}
